import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import KitRegular from './kit-regular-icon.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <KitRegular {...validProps} />;
}
SvgComponent.iconName = 'kitRegular';

export const KitRegularIcon = svgIconWrapper(SvgComponent);
